module.exports = __webpack_public_path__ + "static/media/loader.c5e8a702.gif";